import { useTranslation } from 'react-i18next';

const wasteDumpTypes = () => {
	const { t } = useTranslation();

	return [
		{ id: 'NEW', name: t('waste_dump_type_options.NEW') },
		{ id: 'CONFIRMED', name: t('waste_dump_type_options.CONFIRMED') },
		{ id: 'SANITIZED', name: t('waste_dump_type_options.SANITIZED') },
		{ id: 'DRAFT', name: t('waste_dump_type_options.DRAFT') },
	];
};

export default wasteDumpTypes;
